module.exports = ".alps-list-table-action {\r\n  text-align: center;\n  width:10%;\r\n}\r\n\r\n.alps-list-table-action-add {\r\n  font-size: 18px !important;\r\n  color: #ffffff;\r\n}\r\n\r\n.alps-list-table-action-edit {\r\n  font-size: 14px !important;\r\n  color: #ffffff;\r\n  padding: 0 5px;\r\n  display: inline-block;\r\n}\r\n\r\n.alps-list-table-action-delete {\r\n  font-size: 14px !important;\r\n  color: #ffffff;\r\n  padding: 0 5px;\r\n  display: inline-block;\r\n}\n.alps-list-table-foot{\ntext-align:center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/component/alps-list-table/alps-list-table.component.css
// module id = 506
// module chunks = 16